// ! UTILITY ENUMS TO ASSIST WITH DB
// ! DO NOT CHANGE THESE ENUMS, UNLESS YOU KNOW WHAT THE IMPACT WILL BE
// ! DO NOT RENAME OR MOVE THIS FILE WITHOUT UPDATING ./github/workflows/deploy-stage.yml (the DB should be deployed if these enums change to upsert them correctly)
//* old claim_status.. only utilized by GSP *//
export const ClaimStatusEnum = {
    closedDenied: 'Closed_Denied',
    closedRefunded: 'Closed_Refunded',
    closedReordered: 'Closed_Reordered',
    closedResolved: 'Closed_Resolved',
    inProgress: 'InProgress',
    open: 'Open',
};
// labels used for merchant facing UI
export const shippingClaimStatusName = {
    [ClaimStatusEnum.open]: 'Open',
    [ClaimStatusEnum.closedDenied]: 'Closed - Denied',
    [ClaimStatusEnum.closedRefunded]: 'Closed - Refunded',
    [ClaimStatusEnum.closedReordered]: 'Closed - Reordered',
    [ClaimStatusEnum.inProgress]: 'In Progress',
    [ClaimStatusEnum.closedResolved]: 'Closed - Resolved',
};
// flags on a claimed line item that a reviewer should see before resolving
export const ShippingClaimLineItemTag = {
    hasCustomization: 'has_customization',
    removedFromOrder: 'removed_from_order',
    unfulfilled: 'unfulfilled',
};
export const ClaimReasonEnum = {
    damaged: 'Damaged',
    lost: 'Lost',
    stolen: 'Stolen',
    wrongItem: 'Wrong_Item',
    missingItem: 'Missing_Item',
    qualityIssue: 'Quality_Issue',
    incorrectAddress: 'Incorrect_Address',
    satisfactionGuarantee: 'Satisfaction_Guarantee',
};
// labels used for merchant facing UI
export const shippingClaimReasonName = {
    [ClaimReasonEnum.damaged]: 'Damaged',
    [ClaimReasonEnum.stolen]: 'Stolen',
    [ClaimReasonEnum.lost]: 'Lost',
    [ClaimReasonEnum.wrongItem]: 'Wrong Item',
    [ClaimReasonEnum.missingItem]: 'Missing Item',
    [ClaimReasonEnum.qualityIssue]: 'Quality Issue',
    [ClaimReasonEnum.incorrectAddress]: 'Incorrect Address',
    [ClaimReasonEnum.satisfactionGuarantee]: 'Satisfaction Guarantee',
};
// labels used for merchant facing UI
export const gspClaimReasonLabels = {
    [ClaimReasonEnum.damaged]: 'It was damaged',
    [ClaimReasonEnum.stolen]: 'It was marked delivered but was never received',
    [ClaimReasonEnum.lost]: 'It was lost in transit',
    [ClaimReasonEnum.wrongItem]: 'I received the wrong item(s)',
    [ClaimReasonEnum.missingItem]: 'An item is missing from the order',
    [ClaimReasonEnum.qualityIssue]: 'There is a quality issue with the item(s)',
    [ClaimReasonEnum.incorrectAddress]: 'The item(s) were sent to the wrong address',
    [ClaimReasonEnum.satisfactionGuarantee]: "I'm not satisfied with the quality of the item(s)",
};
export const ClaimResolutionMethodEnum = {
    refund: 'Refund',
    reorder: 'Reorder',
};
// labels used for merchant facing UI
export const shippingClaimResolutionMethodName = {
    [ClaimResolutionMethodEnum.refund]: 'Refund',
    [ClaimResolutionMethodEnum.reorder]: 'Reorder',
};
export var FulfillmentStrategyEnum;
(function (FulfillmentStrategyEnum) {
    FulfillmentStrategyEnum["onOrderCreate"] = "On_Order_Create";
    FulfillmentStrategyEnum["onFirstFulfillment"] = "On_First_Fulfillment";
    FulfillmentStrategyEnum["none"] = "None";
})(FulfillmentStrategyEnum || (FulfillmentStrategyEnum = {}));
export const fulfillmentStrategyName = {
    [FulfillmentStrategyEnum.none]: 'No Fulfillment',
    [FulfillmentStrategyEnum.onFirstFulfillment]: 'At First Fulfillment',
    [FulfillmentStrategyEnum.onOrderCreate]: 'At Order Create',
};
/** @deprecated use Source */ // TODO remove
export var ClaimSourceEnum;
(function (ClaimSourceEnum) {
    /** @deprecated use Retool */
    ClaimSourceEnum["corsoSupport"] = "Corso_Support";
    /** @deprecated use reorderRequest */
    ClaimSourceEnum["customer"] = "Customer";
    /** @deprecated not in use */
    ClaimSourceEnum["merchant"] = "Merchant";
    ClaimSourceEnum["retool"] = "Retool";
    ClaimSourceEnum["reorderRequest"] = "Reorder_Request";
    ClaimSourceEnum["customerUi"] = "Customer_UI";
    ClaimSourceEnum["reorderRequestMerchant"] = "Reorder_Request_Merchant";
    ClaimSourceEnum["gorgiasTicketWidget"] = "Gorgias_Ticket_Widget";
    ClaimSourceEnum["zowieInboxIntegration"] = "Zowie_Inbox_Integration";
})(ClaimSourceEnum || (ClaimSourceEnum = {}));
// ! note to future us, we aren't actually using the shopify status, we are using our own status,
// ! this should be changed to an enum that matches what shopify responds with the shopify values
/**
 * @see https://shopify.dev/docs/api/admin-graphql/latest/enums/AppSubscriptionStatus
 */
// TODO move this to a shared file
export var ShopifyAppSubscriptionStatusEnum;
(function (ShopifyAppSubscriptionStatusEnum) {
    ShopifyAppSubscriptionStatusEnum["pending"] = "PENDING";
    ShopifyAppSubscriptionStatusEnum["active"] = "ACTIVE";
    ShopifyAppSubscriptionStatusEnum["expired"] = "EXPIRED";
    ShopifyAppSubscriptionStatusEnum["uninstalled"] = "UNINSTALLED";
    ShopifyAppSubscriptionStatusEnum["declined"] = "DECLINED";
    ShopifyAppSubscriptionStatusEnum["frozen"] = "FROZEN";
    ShopifyAppSubscriptionStatusEnum["cancelled"] = "CANCELLED";
    /** @deprecated Shopify has deprecated this as of `2021-01`; however, it currently still exists. */
    ShopifyAppSubscriptionStatusEnum["accepted"] = "ACCEPTED";
})(ShopifyAppSubscriptionStatusEnum || (ShopifyAppSubscriptionStatusEnum = {}));
//# sourceMappingURL=gsp.js.map